import {
  buildWaLink,
  openWhatsApp,
  WHATSAPP_NUMBERS,
} from "@/lib/constants";
import { WhatsAppIcon } from "@/components/WhatsAppIcon";

const sizes = {
  sm: "px-5 py-2.5 text-sm",
  md: "px-6 py-3.5 text-base",
  lg: "px-8 py-4 text-base sm:text-lg",
};

export const WhatsAppButton = ({
  children,
  location,
  testId,
  size = "md",
  pulse = false,
  className = "",
}) => (
  <a
    href={buildWaLink(WHATSAPP_NUMBERS[0])}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={testId}
    onClick={(e) => {
      e.preventDefault();
      openWhatsApp(location);
    }}
    className={`inline-flex items-center justify-center gap-2.5 rounded-full bg-wa text-white font-heading font-bold tracking-tight shadow-[0_4px_14px_0_rgb(37,211,102,0.39)] transition-[background-color,transform,box-shadow] duration-200 hover:bg-wa-dark hover:scale-[1.03] hover:shadow-[0_8px_24px_0_rgb(37,211,102,0.45)] focus:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-2 active:scale-100 ${sizes[size]} ${pulse ? "animate-wa-pulse" : ""} ${className}`}
  >
    <WhatsAppIcon className="w-5 h-5 shrink-0" />
    <span>{children}</span>
  </a>
);
